export class Features {
	enablePortalAutopay: boolean = false;
	enableCardPresentVTSale: boolean = false;
	portalMultiAccountPaymentPlan: boolean = false;
	enableApplePay: boolean = false;
	consumerPortalMultiZidEzPay: boolean = false;
	payableSchedule: boolean = false;
	mfaConsumerPortal: boolean = false;
	useRecaptchaV2ForEzPay: boolean = false;
	unvalidatedEzPayMFA: boolean = false;

	constructor(params: any) {
		try {			
			if (params) {
				// We still keep this method for future use
				this.enablePortalAutopay = params.enablePortalAutopay || false;
				this.enableCardPresentVTSale = params.enableCardPresentVTSale;
				this.portalMultiAccountPaymentPlan = params.portalMultiAccountPaymentPlan || false;
				this.enableApplePay = params.applePay || false;
				this.consumerPortalMultiZidEzPay = params.consumerPortalMultiZidEzPay || false;
				this.payableSchedule = params.payableSchedule || false;
				this.mfaConsumerPortal = params.mfaConsumerPortal || false;
				this.useRecaptchaV2ForEzPay = params.useRecaptchaV2ForEzPay || false;
				this.unvalidatedEzPayMFA = params.unvalidatedEzPayMFA || false;
			} else {
				console.info('No Features Enabled.');
			}
		}
		catch (err) {
			console.error('Error occurred in features ctor');
		}
	}
}
